import "./style"
import {ShapeComponent, shapeComponent} from "set-state-compare/build/shape-component.js"
import memo from "set-state-compare/build/memo.js"

export default memo(shapeComponent(class FlashMessagesFlashMessage extends ShapeComponent {
  static defaultProps = {
    timeout: 4000
  }

  static propTypes = PropTypesExact({
    className: PropTypes.string,
    component: PropTypes.node,
    count: PropTypes.number.isRequired,
    message: PropTypes.string,
    onRequestRemove: PropTypes.func.isRequired,
    title: PropTypes.string,
    type: PropTypes.string.isRequired,
    timeout: PropTypes.oneOfType([PropTypes.bool, PropTypes.number])
  })

  messageTimeout = null

  componentDidMount() {
    if (this.p.timeout) {
      this.startTimeout()
    }
  }

  onMouseEnter = () => {
    clearTimeout(this.messageTimeout)
  }

  startTimeout = () => {
    this.messageTimeout = setTimeout(this.p.onRequestRemove, this.p.timeout)
  }

  onMouseLeave = () => {
    if (this.p.timeout) {
      this.startTimeout()
    }
  }

  onRemovedClicked = (e) => {
    e.preventDefault()

    this.p.onRequestRemove()
  }

  render() {
    const {className, component, message, title, type} = this.props

    return (
      <div
        className={classNames("nemoa-components-flash-messages-flash-message", className)}
        data-type={type}
        onMouseEnter={this.onMouseEnter}
        onMouseLeave={this.onMouseLeave}
      >
        <div className="d-flex">
          <div className="flex-grow-1">
            {title &&
              <div className="mb-1 flash-message-title">
                <b>{title}</b>
              </div>
            }
          </div>
          <Icon className="close-flash-message-button" icon="times" onClick={this.onRemovedClicked} size="small" />
        </div>
        <div className="flash-message">
          {component}
          {message}
        </div>
      </div>
    )
  }
}))
